import AppColorBadge from './AppColorBadge.vue';

export default AppColorBadge;



// WEBPACK FOOTER //
// ./src/uikit/components/AppColorBadge/index.ts